/**
 * Husleie.no API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0
 * Contact: devops+api@husleie.no
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import DefaultErrorResponseScheme from '../model/DefaultErrorResponseScheme';
import InlineObject10 from '../model/InlineObject10';
import InlineObject11 from '../model/InlineObject11';
import InlineResponse20013 from '../model/InlineResponse20013';
import InlineResponse20014 from '../model/InlineResponse20014';
import InlineResponse2005 from '../model/InlineResponse2005';
import InlineResponse2007 from '../model/InlineResponse2007';

/**
 * LeaseTermination service.
 * @module api/LeaseTerminationApi
 * @version 1.0
 */
export default class LeaseTerminationApi {

    /**
     * Constructs a new LeaseTerminationApi. 
     * @alias module:api/LeaseTerminationApi
     * @class
     * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
     * default to {@link module:ApiClient#instance} if unspecified.
     */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the createLeaseTerminationSession operation.
     * @callback module:api/LeaseTerminationApi~createLeaseTerminationSessionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/InlineResponse20013} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Creates a new lease termination session object.
     * Creates a new lease termination session object that the client can use to store lease termination session information.
     * @param {Object} opts Optional parameters
     * @param {String} opts.rentalObjectId 
     * @param {String} opts.tenancyId 
     * @param {module:api/LeaseTerminationApi~createLeaseTerminationSessionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/InlineResponse20013}
     */
    createLeaseTerminationSession(opts, callback) {
        opts = opts || {};
        let postBody = null;


        let pathParams = {};
        let queryParams = {};
        let headerParams = {};
        let formParams = {
            'rental_object_id': opts['rentalObjectId'],
            'tenancy_id': opts['tenancyId']
        };

        let authNames = ['APIKeyHeader'];
        let contentTypes = ['application/x-www-form-urlencoded'];
        let accepts = ['*/*'];
        let returnType = InlineResponse20013;

        return this.apiClient.callApi(
            '/lease_termination', 'POST',
            pathParams, queryParams, headerParams, formParams, postBody,
            authNames, contentTypes, accepts, returnType, callback
        );
    }

    /**
     * Callback function to receive the result of the getLeaseTerminationSession operation.
     * @callback module:api/LeaseTerminationApi~getLeaseTerminationSessionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/InlineResponse20014} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Returns the content of a lease termination session
     * Returns the content of a lease termination session
     * @param {String} id 
     * @param {module:api/LeaseTerminationApi~getLeaseTerminationSessionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/InlineResponse20014}
     */
    getLeaseTerminationSession(id, callback) {
        let postBody = null;

        // verify the required parameter 'id' is set
        if (id === undefined || id === null) {
            throw new Error("Missing the required parameter 'id' when calling getLeaseTerminationSession");
        }


        let pathParams = {
            'id': id
        };
        let queryParams = {};
        let headerParams = {};
        let formParams = {};

        let authNames = ['APIKeyHeader'];
        let contentTypes = [];
        let accepts = ['*/*'];
        let returnType = InlineResponse20014;

        return this.apiClient.callApi(
            '/lease_termination/{id}', 'GET',
            pathParams, queryParams, headerParams, formParams, postBody,
            authNames, contentTypes, accepts, returnType, callback
        );
    }

    /**
     * Callback function to receive the result of the leaseTerminationDownloadDocument operation.
     * @callback module:api/LeaseTerminationApi~leaseTerminationDownloadDocumentCallback
     * @param {String} error Error message, if any.
     * @param {File} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Download pdf
     * This method will start a download of the pdf. If the pdf is not finished yet, it will wait for the rendering
     * @param {String} id 
     * @param {module:api/LeaseTerminationApi~leaseTerminationDownloadDocumentCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link File}
     */
    leaseTerminationDownloadDocument(id, callback) {
        let postBody = null;

        // verify the required parameter 'id' is set
        if (id === undefined || id === null) {
            throw new Error("Missing the required parameter 'id' when calling leaseTerminationDownloadDocument");
        }


        let pathParams = {
            'id': id
        };
        let queryParams = {};
        let headerParams = {};
        let formParams = {};

        let authNames = ['APIKeyHeader'];
        let contentTypes = [];
        let accepts = ['application/pdf'];
        let returnType = File;

        return this.apiClient.callApi(
            '/lease_termination/{id}/download_document', 'GET',
            pathParams, queryParams, headerParams, formParams, postBody,
            authNames, contentTypes, accepts, returnType, callback
        );
    }

    /**
     * Callback function to receive the result of the leaseTerminationStoreDocument operation.
     * @callback module:api/LeaseTerminationApi~leaseTerminationStoreDocumentCallback
     * @param {String} error Error message, if any.
     * @param {module:model/InlineResponse2007} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Stores and renders the lease termination letter
     * This method will start the rendering and storing of the lease termination document
     * @param {String} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/InlineObject11} opts.leaseTermination 
     * @param {module:api/LeaseTerminationApi~leaseTerminationStoreDocumentCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/InlineResponse2007}
     */
    leaseTerminationStoreDocument(id, opts, callback) {
        opts = opts || {};
        let postBody = opts['leaseTermination'];

        // verify the required parameter 'id' is set
        if (id === undefined || id === null) {
            throw new Error("Missing the required parameter 'id' when calling leaseTerminationStoreDocument");
        }


        let pathParams = {
            'id': id
        };
        let queryParams = {};
        let headerParams = {};
        let formParams = {};

        let authNames = ['APIKeyHeader'];
        let contentTypes = [];
        let accepts = ['*/*'];
        let returnType = InlineResponse2007;

        return this.apiClient.callApi(
            '/lease_termination/{id}/store_document', 'POST',
            pathParams, queryParams, headerParams, formParams, postBody,
            authNames, contentTypes, accepts, returnType, callback
        );
    }

    /**
     * Callback function to receive the result of the updateLeaseTerminationSession operation.
     * @callback module:api/LeaseTerminationApi~updateLeaseTerminationSessionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/InlineResponse2005} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Update a lease termination session, replacing the content of the lease termination session
     * Update a lease termination session, replacing the content of the lease termination session
     * @param {String} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/InlineObject10} opts.leaseTermination 
     * @param {module:api/LeaseTerminationApi~updateLeaseTerminationSessionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/InlineResponse2005}
     */
    updateLeaseTerminationSession(id, opts, callback) {
        opts = opts || {};
        let postBody = opts['leaseTermination'];

        // verify the required parameter 'id' is set
        if (id === undefined || id === null) {
            throw new Error("Missing the required parameter 'id' when calling updateLeaseTerminationSession");
        }


        let pathParams = {
            'id': id
        };
        let queryParams = {};
        let headerParams = {};
        let formParams = {};

        let authNames = ['APIKeyHeader'];
        let contentTypes = [];
        let accepts = ['*/*'];
        let returnType = InlineResponse2005;

        return this.apiClient.callApi(
            '/lease_termination/{id}', 'POST',
            pathParams, queryParams, headerParams, formParams, postBody,
            authNames, contentTypes, accepts, returnType, callback
        );
    }


}